export const ADD_KANBAN_ITEMS_TO_CART = 'ADD_KANBAN_ITEMS_TO_CART';
export const ADD_KANBAN_ITEMS_TO_CART_FULFILLED = 'ADD_KANBAN_ITEMS_TO_CART_FULFILLED';
export const ADD_KANBAN_ITEMS_TO_CART_REJECTED = 'ADD_KANBAN_ITEMS_TO_CART_REJECTED';
export const CLEAR_ADD_KANBAN_ITEMS_TO_CART = 'CLEAR_ADD_KANBAN_ITEMS_TO_CART';
export const VERIFY_KANBAN_ITEMS = 'VERIFY_KANBAN_ITEMS';
export const VERIFY_KANBAN_ITEMS_FULFILLED = 'VERIFY_KANBAN_ITEMS_FULFILLED';
export const VERIFY_KANBAN_ITEMS_REJECTED = 'VERIFY_KANBAN_ITEMS_REJECTED';
export const CLEAR_VERIFY_KANBAN_ITEMS = 'CLEAR_VERIFY_KANBAN_ITEMS';
export const PLACE_KANBAN_ORDER = 'PLACE_KANBAN_ORDER';
export const PLACE_KANBAN_ORDER_FULFILLED = 'PLACE_KANBAN_ORDER_FULFILLED';
export const PLACE_KANBAN_ORDER_REJECTED = 'PLACE_KANBAN_ORDER_REJECTED';
export const CLEAR_PLACE_KANBAN_ORDER = 'CLEAR_PLACE_KANBAN_ORDER';
